export default {
  content: {},
  value: "",
};
